jQuery(document).ready(function ($) {
    const horizontal_teaser_galleries = $('.horizontal-teaser__gallery');

    horizontal_teaser_galleries.each(function () {
        const $gallery = $(this);
        const $current = $gallery.find('.horizontal-teaser__gallery--counter .current');

        const update_counter = function (swiper) {
            const slide_number = swiper.realIndex + 1;

            $current.text(String(slide_number).padStart(2, '0'));
        };

        const single_gallery = new Swiper(`#${$gallery.attr('id')}`, {
            loop: true,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            //spaceBetween: 16,

            grabCursor: true,

            watchOverflow: false,

            autoplay: true,
            delay: 8000,

            navigation: {
                prevEl: '.horizontal-teaser__gallery--prev',
                nextEl: '.horizontal-teaser__gallery--next'
            },

            on: {
                init: update_counter,
                slideChange: update_counter
            }
        });
    });
});